import { render, staticRenderFns } from "./chat-window-messages.vue?vue&type=template&id=4ab93394&scoped=true&"
import script from "./chat-window-messages.vue?vue&type=script&lang=js&"
export * from "./chat-window-messages.vue?vue&type=script&lang=js&"
import style0 from "./chat-window-messages.vue?vue&type=style&index=0&id=4ab93394&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab93394",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ab93394')) {
      api.createRecord('4ab93394', component.options)
    } else {
      api.reload('4ab93394', component.options)
    }
    module.hot.accept("./chat-window-messages.vue?vue&type=template&id=4ab93394&scoped=true&", function () {
      api.rerender('4ab93394', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/components/chat-window-messages/chat-window-messages.vue"
export default component.exports